import { Component, OnInit, ViewChild } from '@angular/core';
import { OrtschaftSelectionComponent } from 'app/shared/widgets/ortschaft/ortschaft-selection.component';
import { TimepointService } from 'app/core/services/timepoint.service';
import { Subscription } from 'rxjs';
import { FormsModule, NgForm } from '@angular/forms';
import { PersonstammpersonService, PersonStammSearchRequestMeta } from 'app/core/personstamm-api';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { submit } from 'app/stammdaten/person-stamm/personstamm.functions';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchStateService } from '../../../../shared/services/search-state.service';
import { AbstractSearchComponent } from '../../../../shared/components/abstract-component/abstract-search.component';
import { SearchMode } from '../../../../shared/enum/searchMode';
import { CapFormColumnsDirective } from '../../../../shared/form-control/form-columns.directive';
import { MetaDirective } from '../../../../shared/directives/meta.directive';
import { CapFormControlComponent } from '../../../../shared/form-control/form-control.component';
import { MetaDisablerDirective } from '../../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../../shared/directives/meta-validator.directive';
import { TeilDatumComponent } from '../../../../shared/widgets/teil-datum/teil-datum.component';
import { CapFormRowDirective } from '../../../../shared/form-control/cap-form-row.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-personstamm-suche-zpv',
  templateUrl: './personstamm-suche-zpv.component.html',
  styleUrls: ['./personstamm-suche-zpv.component.scss'],
  imports: [
    FormsModule,
    CapFormColumnsDirective,
    MetaDirective,
    CapFormControlComponent,
    MetaDisablerDirective,
    MetaValidatorDirective,
    TeilDatumComponent,
    CapFormRowDirective,
    TranslatePipe
  ]
})
export class PersonstammSucheZpvComponent extends AbstractSearchComponent implements OnInit {
  @ViewChild('form', { static: false })
  form: NgForm;

  @ViewChild(OrtschaftSelectionComponent, { static: false })
  private ortschaftSelection: OrtschaftSelectionComponent;

  _searchMode: PersonStammSearchRequestMeta.SearchModeEnum = PersonStammSearchRequestMeta.SearchModeEnum.ZPV_SUCHE;

  private subscription: Subscription;

  zpvRequest: PersonStammSearchRequestMeta;

  constructor(
    private zpvService: PersonstammpersonService,
    private route: ActivatedRoute,
    private router: Router,
    private timepointService: TimepointService,
    stateService: SearchStateService
  ) {
    super(stateService);
    keysToTranslate<string>([
      'BezugZumGrundbuch',
      'MitGrundbuchbezug',
      'ohneGrundbuchbezug',
      'personstamm.ZPVNummer',
      'personstamm.tab.ZPVSuche',
      'EingabeMussValideUIDSein',
      'EingabeMussValideAHVNummerSein',
      'EingabeMussValidePLZSein'
    ]);
  }

  ngOnInit() {
    this.subscription = this.zpvService
      .searchStammPersonTemplate(PersonStammSearchRequestMeta.SearchModeEnum.ZPV_SUCHE)
      .subscribe((template) => {
        this.zpvRequest = this.copyLastRequest(template, SearchMode.searchZpv);
      });
  }

  onSubmit(): void {
    this.timepointService.resetTimepoint();
    this.stateService.lastRequest = this.zpvRequest;
    this.stateService.lastSearchMode = SearchMode.searchZpv;
    submit(this.form, SearchMode.searchZpv, this.zpvRequest, this.router, this.route);
  }

  onReset() {
    this.form.reset();
    this.subscription = this.zpvService.searchStammPersonTemplate(this._searchMode).subscribe((template) => {
      this.zpvRequest = template;
    });
  }

  emptyOrtschaftSearch() {
    this.ortschaftSelection.onClear();
  }
}
